module.exports = __webpack_public_path__ + "img/img_share.90aab894.png";